/* ------------------------------------------------
** Dialog
// dialog格式
<div class="dialog" dialog-name="login">
    <div>
        <div>
            <span class="close"><i class="iconfont icon-close"></i></span>
            <!-- 这儿是内容 -->
        </div>
    </div>
</div>
// 按钮格式
<button class="dialog-show" dialog-name="login"></button>
** 触发按钮和dialog中的dialog-name需保持一致
--------------------------------------------------*/
//Dialog初始化
$(function () {
    // TAB组件事件切换函数
    $(".dialog-show").click(function () {
        const name = $(this).attr("dialog-name");
        $(`.dialog`).hide();
        $(`.dialog[dialog-name='${name}']`).show();
    });
    $(".dialog .close").click(function () {
        //const name = $(this).parents(".dialog").attr("dialog-name");
        $(`.dialog`).hide();
    });
});

// 对话框显示/隐藏切换
function clickDialog() {
    $("#dialog").toggle();
};